export default {
  title: {
    id: 'buyback_options_Pricing_rules_tab_title',
    defaultMessage: 'Add pricing rule',
  },
  batteryFeeCardTitle: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_block_title_',
    defaultMessage: 'Set a pricing rule for MacBooks with a used battery',
  },
  batteryFeeCardDescription: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_block_description',
    defaultMessage:
      'Buying a MacBook with used battery? No problem. Set a customized amount to automatically deduct from your offers (only applies to functional offers).',
  },
  batteryFeeInputLabel: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_input_label',
    defaultMessage: 'Amount',
  },
  batteryFeeFormSubmit: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_block_CTA_',
    defaultMessage: 'Add this rule',
  },
  toastSuccessTitle: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_toast_success_title',
    defaultMessage: 'Pricing rule saved',
  },
  toastErrorTitle: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_toast_error_title',
    defaultMessage: 'Hold up',
  },
  toastErrorContent: {
    id: 'buyback_options_pricing_rules_tab_Macbook_battery_toast_error_content',
    defaultMessage: 'We couldn’t save your pricing rule. Try again?',
  },
}
